import JassEnum from './enum';

/**
 * type placement
 */
export default class JassPlacement extends JassEnum {}
